<script lang="ts">
import { defineComponent, PropType } from 'vue'

import {
  Confirmation,
  CricketIncidentId,
  IllegalBallAttributesId,
  LegalBallAttributesId,
  YesNoEnum,
} from '@collector/sportsapi-client-legacy'
import Button from '@mobile/components/Button/Button.vue'
import { PopupContext } from '@mobile/views/Relation/Shared/Popup/builder/types'
import { useIncidentAction } from '@mobile/views/Relation/Shared/Popup/useIncidentAction'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'

import { useCricketConfiguration } from '../../CricketRelationDependencies/useCricketConfiguration'
import { prepareAdditionalInfo } from '../../prepareAdditionalInfo'
import { BallSummaryPopup } from '../BallSummary/BallSummaryPopup'

export default defineComponent({
  components: { Button },
  props: {
    context: {
      type: Object as PropType<PopupContext | null>,
      required: false,
    },
  },
  setup(props) {
    const eventInjections = useEventInjections()
    const { probableIncidents } = eventInjections
    const { activeParticipant } = useCricketConfiguration()

    function proceed(optionSelected: YesNoEnum): void {
      switch (optionSelected) {
        case YesNoEnum.Yes:
          proceedYesOption()
          break
        case YesNoEnum.No:
          proceedNoOption()
          break
      }
    }

    function proceedYesOption(): void {
      const additionalInfo = prepareAdditionalInfo(
        activeParticipant,
        probableIncidents,
      )

      const incidentActionComposable = useIncidentAction(eventInjections, {
        incident_id: CricketIncidentId.IllegalBall,
        confirmation: Confirmation.ToBeDone,
        attribute_ids: [
          IllegalBallAttributesId.Wides,
          IllegalBallAttributesId.One,
        ],
        additional_info: additionalInfo,
        participant_team_id: activeParticipant.value.participant?.id,
      })

      props.context?.openPopup(BallSummaryPopup, { incidentActionComposable })
    }

    function proceedNoOption(): void {
      const additionalInfo = prepareAdditionalInfo(
        activeParticipant,
        probableIncidents,
      )

      const incidentActionComposable = useIncidentAction(eventInjections, {
        incident_id: CricketIncidentId.LegalBall,
        confirmation: Confirmation.ToBeDone,
        attribute_ids: [LegalBallAttributesId.Runs, LegalBallAttributesId.Zero],
        additional_info: additionalInfo,
        participant_team_id: activeParticipant.value.participant?.id,
      })

      props.context?.openPopup(BallSummaryPopup, { incidentActionComposable })
    }

    return {
      proceed,
      YesNoEnum,
    }
  },
})
</script>

<template>
  <div class="grid h-full w-full place-items-center">
    <div class="flex flex-col">
      <div class="text-cloudygray pb-2 text-center font-bold">Wide?</div>
      <div class="flex space-x-2">
        <Button
          class="w-20"
          :size="'md'"
          :color="'green'"
          @click="proceed(YesNoEnum.Yes)"
        >
          Yes
        </Button>
        <Button
          class="w-20"
          :size="'md'"
          :color="'red'"
          @click="proceed(YesNoEnum.No)"
        >
          No
        </Button>
      </div>
    </div>
  </div>
</template>
